<template>
    <div class="grades_bg">
        <van-image v-if="user.avatar" width="40vw" height="40vw" :src="user.avatar" class="avatar" fit="contain" />
        <van-image v-else width="40vw" height="40vw" src="http://osswx-ahxmgk-com.oss-cn-hangzhou.aliyuncs.com/yun/uploads/image/2020/05/12/8b6c2aebbc075666dde93e2f44bd5f72.jpg" class="avatar" fit="contain" />
        <div class="info">
            <p>{{user.name}}</p>
            <p>得分：{{answer_reslut.point}}分</p>
            <p>用时：{{answer_reslut.user_time}}</p>
        </div>
        <!-- <router-link :to="{name: 'Index'}"><van-button  type="primary" size="large" class="grades_btn" color="#f6b36d">重新答题</van-button></router-link> -->
        <router-link :to="{name: 'Index'}">
            <van-button type="primary" size="large" class="grades_btn" color="#f6b36d">返回首页</van-button>
        </router-link>
        <van-overlay :show="show">
            <div class="wapp">
                <LuckDraw v-model="currIndex" :awards="awards" @start="handleStart" @end="handleEnd" />
                </LuckDraw>
            </div>
        </van-overlay>
    </div>
</template>
<script>
import { getResultInfo, getRedbagCallback } from '@/api/user'
export default {
    data() {
        return {
            id: 0,
            info: this.$store.state.acc,
            user: this.$store.state.user,
            answer_reslut: this.$store.state.answer_reslut,
            currIndex: 5, // 奖品的索引
            awards: [ // 奖品
                { name: '1元', color: '#f9e3bb' },
                { name: '2元', color: '#f8d494' },
                { name: '3元', color: '#f9e3bb' },
                { name: '5元', color: '#f8d494' },
                { name: '10元', color: '#f9e3bb' },
                // { name: '15元', color: '#f8d494' },
                // { name: '20元', color: '#f9e3bb' },
                { name: '谢谢参与', color: '#f8d494' }

            ],
            show: false
        }
    },

    created(e) {

        this.id = this.$route.params.id
        console.log(this.id)
        this.getInfo()
        // console.log(LuckDraw)
    },
    methods: {
        getInfo() {
            this.$toast.loading({
                message: '加载中...',
                forbidClick: false,
                loadingType: 'spinner',
                duration: 10000
            });
            let id = this.answer_reslut.id
            if (!id) id = this.id
            getResultInfo({ id: id }).then(res => {
                console.log(res);
                console.log(this.info);
                this.$toast.clear()
                this.answer_reslut = res.result
                if(res.code && res.code != 200) {
                  this.$dialog.alert({
                    message: res.message,
                  });
                  return
                }
                if (this.info.is_redbag == 1 && res.result.point >= this.info.send_redbag_point) {

                    if (res.redbag.status == 1) {
                        this.show = true
                        if (res.redbag.info.index >= 0) this.currIndex = res.redbag.info.index

                    } else {
                        this.$dialog.alert({
                            message: res.redbag.msg,
                        });
                    }
                } else if (this.info.is_redbag == 1) {
                    this.$dialog.alert({
                        message: '请再接再厉，只有得分' + this.info.send_redbag_point + '分,才能抽奖哦！',
                    });
                }else{
                  this.$dialog.alert({
                    message: res.message,
                  });

                }
            })
        },
        handleStart() {
            console.log('开始抽奖 ')
        },
        handleEnd(index) {
            // if(this.currIndex == 0) {
            //   this.$dialog.alert({
            //     message: '感谢参与，请明日再来',
            //   }).then(res=>{
            //     this.show = false
            //   })
            // }else {
            var message = ''
            var text = ''
            if (this.currIndex == 5) {
                message = '谢谢参与，请再接再厉'
                text = '确定'
                this.$dialog.alert({
                    message: message,
                    confirmButtonText: text
                }).then(res => {
                    this.show = false
                })
                return false

            } else {
                message = '恭喜您，抽得' + this.awards[this.currIndex].name
                text = '立刻领奖'
            }
            this.$dialog.alert({
                message: message,
                confirmButtonText: text
            }).then(res => {
                this.show = false
                getRedbagCallback().then(res => {
                    this.$toast('红包稍后发放，请注意查收！');

                })
            })
            // }

        }
    }
}
</script>
<style>
.grades_bg {
    background: url(../assets/images/bg.jpg) no-repeat center;
    background-size: cover;
    width: 100vw;
    height: 100vh;
    overflow: hidden;
    font-size: 1.0em;
    text-align: center;
}

.avatar {
    margin-top: 15vh;
    margin-bottom: 4vh;
}

.avatar img {
    border-radius: 50%;
}

.grades_bg p {
    color: #333;
    margin: 0.5em 0 0.7em;
    font-weight: bold;
}

.grades_bg span {
    color: #fff;
    margin: 0 1.5em 0 1.2em;
}

.grades_btn {
    margin-top: 2vh;
    width: 70vw;
    height: 7vh;
    line-height: 7vh;
    font-size: 5vw;
}

.info p {
    color: #000;
}

.wapp {
    position: relative;
    top: 20%;
    margin: 20px auto;
    width: 85vw;
}

.wapp canvas {
    margin: 0 auto;
    width: 100%;
    height: 100%;
}
</style>